import { Typography } from "@mui/material";
import { FC } from "react";

const DefaultError: FC = () => {

    return (
        <Typography 
            variant="h1"
        >
            An error has occurred
        </Typography>
    );
}

export default DefaultError;